import { Routes, Route, Navigate } from 'react-router-dom'
import { lazy, Suspense } from 'react'
import MainLayout from '@/components/layouts/MainLayout'
import AuthLayout from '@/components/layouts/AuthLayout'
import ProtectedRoute from '@/components/shared/ProtectedRoute'
import Spinner from '@/components/ui/Spinner'

// Lazy load pages for code splitting
const LoginPage = lazy(() => import('@/pages/auth/LoginPage'))
const GitHubCallbackPage = lazy(() => import('@/pages/auth/GitHubCallbackPage'))
const GitHubOrgSelectPage = lazy(() => import('@/pages/auth/GitHubOrgSelectPage'))
const DashboardPage = lazy(() => import('@/pages/dashboard'))
const AlertsPage = lazy(() => import('@/pages/alerts/AlertsPage'))
const AlertDetailPage = lazy(() => import('@/pages/alerts/AlertDetailPage'))
const TeamsPage = lazy(() => import('@/pages/teams/TeamsPage'))
const TeamDetailPage = lazy(() => import('@/pages/teams/TeamDetailPage'))
const SchedulesPage = lazy(() => import('@/pages/schedules/SchedulesPage'))
const ScheduleDetailPage = lazy(() => import('@/pages/schedules/ScheduleDetailPage'))
const EscalationsPage = lazy(() => import('@/pages/escalations/EscalationsPage'))
const EscalationDetailPage = lazy(() => import('@/pages/escalations/EscalationDetailPage'))
const UsersPage = lazy(() => import('@/pages/users/UsersPage'))
const IntegrationsPage = lazy(() => import('@/pages/integrations/IntegrationsPage'))
const IntegrationDetailPage = lazy(() => import('@/pages/integrations/IntegrationDetailPage'))
const SettingsPage = lazy(() => import('@/pages/settings/SettingsPage'))

function PageLoader() {
  return (
    <div className="flex items-center justify-center min-h-screen">
      <Spinner size="lg" />
    </div>
  )
}

export default function App() {
  return (
    <Suspense fallback={<PageLoader />}>
      <Routes>
        {/* Auth Routes */}
        <Route element={<AuthLayout />}>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/auth/github/callback" element={<GitHubCallbackPage />} />
          <Route path="/auth/github/select-org" element={<GitHubOrgSelectPage />} />
        </Route>

        {/* Protected Routes */}
        <Route element={<ProtectedRoute />}>
          <Route element={<MainLayout />}>
            <Route path="/dashboard" element={<DashboardPage />} />
            <Route path="/alerts" element={<AlertsPage />} />
            <Route path="/alerts/:id" element={<AlertDetailPage />} />
            <Route path="/teams" element={<TeamsPage />} />
            <Route path="/teams/:id" element={<TeamDetailPage />} />
            <Route path="/schedules" element={<SchedulesPage />} />
            <Route path="/schedules/:id" element={<ScheduleDetailPage />} />
            <Route path="/escalation-policies" element={<EscalationsPage />} />
            <Route path="/escalation-policies/:id" element={<EscalationDetailPage />} />
            <Route path="/users" element={<UsersPage />} />
            <Route path="/integrations" element={<IntegrationsPage />} />
            <Route path="/integrations/:id" element={<IntegrationDetailPage />} />
            <Route path="/settings" element={<SettingsPage />} />
          </Route>
        </Route>

        {/* Default redirect */}
        <Route path="/" element={<Navigate to="/dashboard" replace />} />
        <Route path="*" element={<Navigate to="/dashboard" replace />} />
      </Routes>
    </Suspense>
  )
}
